/**
 * An entity handle packs an index and a generation into one 32-bit number:
 *
 *   bits  0..19  index      (up to 1 048 575 live slots)
 *   bits 20..31  generation (wraps at 4096)
 *
 * Slots are recycled through a free list. The generation is bumped on destroy,
 * so a stale handle pointing at a recycled slot fails validation instead of
 * silently addressing a different entity — the classic ECS use-after-free bug.
 */
export type Entity = number

export const NULL_ENTITY: Entity = -1

export const INDEX_BITS = 20
export const INDEX_MASK = (1 << INDEX_BITS) - 1
export const MAX_ENTITIES = INDEX_MASK + 1
export const GENERATION_MASK = 0xfff

export function entityIndex(e: Entity): number {
  return e & INDEX_MASK
}

export function entityGeneration(e: Entity): number {
  return (e >>> INDEX_BITS) & GENERATION_MASK
}

export function makeEntity(index: number, generation: number): Entity {
  return (index & INDEX_MASK) | ((generation & GENERATION_MASK) << INDEX_BITS)
}
